module.exports = __webpack_public_path__ + "static/media/Filter.50d7faf5.svg";